/* eslint-disable @typescript-eslint/no-explicit-any */
import { getFileExtension } from '@/lib/utils';

import type {
  KnowledgeBase,
  KnowledgeBaseDetail,
  KnowledgeBaseFile,
  KnowledgeBaseSyncStatus,
} from '@/types/knowledge.type';

export const mapKnowledgeBaseResponse = (data: Record<string, any>): KnowledgeBase => ({
  kb_id: data.kb_id,
  name: data.name,
  kb_description: data.kb_description,
  updated_at: data.updated_at,
});

const mapKnowledgeBaseFile = (file: Record<string, any>): KnowledgeBaseFile => ({
  file_path: file.file_path,
  updated_at: file.updated_at,
  extension: file.file_path ? getFileExtension(file.file_path) : '',
});

export const mapKnowledgeBaseDetailResponse = (
  response: Record<string, any>
): KnowledgeBaseDetail => {
  const data = response.data;
  return {
    kb_id: data.kb_id,
    name: data.name,
    kb_description: data.kb_description,
    updated_at: data.updated_at,
    file_list: data.file_list?.map(mapKnowledgeBaseFile) || [],
  };
};

export const mapKnowledgeBaseSyncStatusResponse = (
  response: Record<string, any>
): KnowledgeBaseSyncStatus => {
  const data = response.data;
  return {
    kb_id: data.kb_id,
    name: data.name,
    ingestion_status: data.ingestion_status,
    kb_metadata: data.kb_metadata,
  };
};

export const mapKnowledgeBaseCreateResponse = (response: Record<string, any>): KnowledgeBase => {
  return mapKnowledgeBaseResponse(response.data);
};

export const mapFilePreviewUrlResponse = (response: Record<string, any>): string => {
  return response.data;
};
